import tracking from 'dibs-tracking';

const SIDEBAR = 'SIDEBAR';
const SELLER_GRID = 'SELLER_GRID';
const SIMILAR_ITEM_GRID = 'SIMILAR_ITEM_GRID';
const VISUALLY_SIMILAR_ITEM_GRID = 'VISUALLY_SIMILAR_ITEM_GRID';
const SEARCH_BROWSE = 'SEARCH_BROWSE';
const ZOOM_MODAL = 'ZOOM_MODAL';
const VIEW_IN_ROOM = 'VIEW_IN_ROOM';

export const locations = {
    SIDEBAR,
    SELLER_GRID,
    SIMILAR_ITEM_GRID,
    VISUALLY_SIMILAR_ITEM_GRID,
    SEARCH_BROWSE,
    ZOOM_MODAL,
    VIEW_IN_ROOM,
};

export const authLabels = {
    SIDEBAR: 'save item - product page',
    SELLER_GRID: 'save item - product page - more from dealer',
    SIMILAR_ITEM_GRID: 'save item - product page - you may also like',
    SEARCH_BROWSE: 'save item - search/browse',
};

const heartLabels = {
    SIDEBAR: 'PDP',
    SELLER_GRID: 'PDP - more from dealer',
    SIMILAR_ITEM_GRID: 'PDP - you may also like',
    VISUALLY_SIMILAR_ITEM_GRID: 'PDP - visually similar item',
    SEARCH_BROWSE: 'search/browse',
    VIEW_IN_ROOM: 'view in room',
};

const folderLabels = {
    SEARCH_BROWSE: 'search/browse',
    PDP: 'pdp',
};

function trackHeartEvent(location, action) {
    tracking.trackEvent({
        action,
        category: 'item favoriting',
        label: heartLabels[location],
    });
}

export const trackHeartFavorited = location => trackHeartEvent(location, 'item added');
export const trackHeartUnfavorited = location => trackHeartEvent(location, 'item removed');

function trackFolderEvent(action, location, noteIncluded, itemPk) {
    const label = folderLabels[location] || folderLabels.PDP;

    tracking.trackEvent({
        action,
        label,
        category: 'item favoriting',
        value: noteIncluded ? 1 : 0,
        additional: itemPk ? { itemPk } : {},
    });
}

const trackFolderClick = location => trackFolderEvent('item favoriting folder clicked', location);
const trackItemRemoved = location => trackFolderEvent('item removed from folder', location);
const trackItemAdded = (location, noteIncluded, itemPk) =>
    trackFolderEvent('item added into folder', location, noteIncluded, itemPk);
const trackFolderCreated = (location, noteIncluded) =>
    trackFolderEvent('item favoriting folder created', location, noteIncluded);

export const folderTrackingHooks = {
    trackFolderClick,
    trackItemRemoved,
    trackItemAdded,
    trackFolderCreated,
};
